import * as React from 'react';
import * as RequestParams from '../config/RequestParams';
import Iframe from './Iframe';
import * as MatchAPI from '../api/match';
import styles from './Overview.module.css';
const Overview = ({ requestParams, config }) => {
    const size = requestParams.size;
    const template = requestParams.template;
    const sport = requestParams.sport;
    if (!size || !template)
        return null;
    const supportedSizes = config.getSupportedSizesByTemplate(template);
    const supportedBettingTypes = config.getSupportedBettingTypesByTemplate(template);
    const supportedSports = config.supportedSports || Object.keys(MatchAPI.Sport);
    function updateSport(sport) {
        const url = new URL(window.location.href);
        url.searchParams.set(RequestParams.RequestParam.sport, sport);
        history.pushState({}, '', url.toString());
    }
    return (React.createElement("div", null,
        React.createElement("div", { className: styles.buttonPanel }, supportedSports.map(supportedSport => (React.createElement("div", { key: supportedSport, onClick: () => updateSport(supportedSport), className: `${styles.button} ${supportedSport === sport ? styles.active : ''}` }, supportedSport)))),
        sport ? (React.createElement("div", null,
            React.createElement("h1", null, sport),
            React.createElement("div", { style: { display: 'flex', flexWrap: 'wrap' } }, supportedBettingTypes.map(bettingType => {
                const url = new URL(window.location.origin + window.location.pathname);
                url.searchParams.set(RequestParams.RequestParam.market, bettingType);
                url.searchParams.set(RequestParams.RequestParam.sport, sport);
                if (requestParams.mocks === 'true') {
                    url.searchParams.set(RequestParams.RequestParam.mocks, 'true');
                }
                url.searchParams.set(RequestParams.RequestParam.matchCount, String(requestParams.slide.length));
                url.searchParams.set(RequestParams.RequestParam.autoFill, String(false));
                url.searchParams.set(RequestParams.RequestParam.template, template);
                return (React.createElement("div", { key: bettingType, style: { margin: '0 10px' } },
                    React.createElement("h2", null, bettingType),
                    React.createElement(Iframe, { baseUrl: url.toString(), size: size, showCode: false, showOverview: false, supportedSizes: supportedSizes })));
            })))) : (React.createElement("h1", { style: { textAlign: 'center' } }, "Please choose a sport"))));
};
export default Overview;
//# sourceMappingURL=Overview.js.map